import { isArray, isString } from 'vdlib';
import Store from 'data/Store';

const LookupsHelper = {
  getByDescription: (lookupArrayOrLookupName, description) => {
    let lookup = isString(lookupArrayOrLookupName)
      ? ((Store.getState().app || {}).lookups || {})[lookupArrayOrLookupName]
      : lookupArrayOrLookupName;

    if (!isArray(lookup))
      return console.error(
        'getByDescription: invalid lookup',
        lookupArrayOrLookupName
      );

    return lookup.find(l => l.Description === description);
  },
  getIdByDescription: (lookupArrayOrLookupName, description) => {
    let lookup = LookupsHelper.getByDescription(
      lookupArrayOrLookupName,
      description
    );
    return lookup == null ? null : lookup.ID;
  },
  get: (lookupArrayOrLookupName, id) => {
    let lookup = isString(lookupArrayOrLookupName)
      ? ((Store.getState().app || {}).lookups || {})[lookupArrayOrLookupName]
      : lookupArrayOrLookupName;

    if (!isArray(lookup))
      return console.error(
        'getByDescription: invalid lookup',
        lookupArrayOrLookupName
      );

    return lookup.find(l => l.ID == id); //eslint-disable-line
  },
  getDescription: (lookupArrayOrLookupName, id) => {
    let lookup = LookupsHelper.get(lookupArrayOrLookupName, id);
    return lookup == null ? null : lookup.Description;
  },
};

export default LookupsHelper;
